import * as React from "react";
// import Link from "next/link";
import * as NavigationMenu from "@radix-ui/react-navigation-menu";
import { cn } from "@/lib/utils";
import { ChevronDownIcon } from "lucide-react";
import { NavItem, NavSubItem } from "@/app/components/header-client";

interface Props {
    listItem: NavItem;
    active: boolean;
    key: string;
}

const NavigationMenuComponent = ({ listItem, active = false, key }: Props) => {
    return (
        <NavigationMenu.Root className="relative flex flex-col items-center" key={key}>
            <NavigationMenu.List className="center m-0 list-none p-0">
                <NavigationMenu.Item>
                    <NavigationMenu.Trigger
                        className="group flex h-[24px] select-none items-center gap-0.5 leading-none outline-none"
                        onClick={(event) => {
                            event.preventDefault();
                            return false;
                        }}
                    >
                        <div className="animate-fade relative flex cursor-pointer items-center text-sm font-semibold text-slate-900 hover:text-gray-900">
                            <div
                                className={cn(
                                    "flex items-center text-md",
                                    active ? "font-semibold text-slate-900" : "text-slate-500",
                                )}
                            >
                                {listItem.label}
                                <ChevronDownIcon
                                    className="text-violet10 duration-[250] relative -top-[0.5px] h-5 w-5 transition-transform ease-in group-data-[state=open]:-rotate-180"
                                    aria-hidden
                                />
                            </div>
                        </div>
                    </NavigationMenu.Trigger>
                    <NavigationMenu.Content className="data-[motion=from-end]:animate-enterFromRight data-[motion=from-start]:animate-enterFromLeft data-[motion=to-end]:animate-exitToRight data-[motion=to-start]:animate-exitToLeft absolute left-0 top-0 sm:w-auto">
                        <ul className="m-0 flex min-w-[180px] list-none flex-col p-0">
                            {listItem.subItems?.map((item: NavSubItem, index: number) => {
                                return (
                                    <ListItem
                                        href={item.href}
                                        active={item.isActive}
                                        title=""
                                        className="text-nowrap"
                                        key={index}
                                    >
                                        {item.label}
                                    </ListItem>
                                );
                            })}
                        </ul>
                    </NavigationMenu.Content>
                </NavigationMenu.Item>

                <NavigationMenu.Indicator className="data-[state=hidden]:animate-fadeOut data-[state=visible]:animate-fadeIn top-full z-10 flex h-2.5 items-end justify-center overflow-hidden transition-[width,transform_250ms_ease]">
                    <div className="relative top-[70%] size-2.5 rotate-45 rounded-tl-sm bg-white" />
                </NavigationMenu.Indicator>
            </NavigationMenu.List>

            <div className="absolute top-full flex w-auto flex-col justify-center p-2">
                <NavigationMenu.Viewport className="data-[state=closed]:animate-scaleOut data-[state=open]:animate-scaleIn relative mt-1 h-[var(--radix-navigation-menu-viewport-height)] w-full origin-[top_center] overflow-hidden rounded-md border border-gray-300 bg-white shadow-[0_0_5px_2px] shadow-gray-200 transition-[width,_height] duration-300 sm:w-[var(--radix-navigation-menu-viewport-width)]" />
            </div>
        </NavigationMenu.Root>
    );
};

type ListItemProps = React.ComponentPropsWithoutRef<"a"> & {
    title: string;
    active?: boolean;
};

const ListItem = React.forwardRef<HTMLAnchorElement, ListItemProps>(
    ({ className, children, active, /* title, */ ...props }, forwardedRef) => (
        <li>
            <NavigationMenu.Link asChild>
                <a
                    className={cn(
                        "focus:shadow-violet7 block select-none px-4 py-3 text-[15px] leading-none no-underline outline-none transition-colors hover:bg-brand-blue-500 hover:text-white focus:shadow-[0_0_0_2px]",
                        active ? "font-semibold text-slate-900" : "font-semibold text-slate-500",
                        className,
                    )}
                    {...props}
                    ref={forwardedRef}
                >
                    {/* <div className="text-violet12 mb-[5px] font-medium leading-[1.2]">{title}</div> */}
                    <p className={cn("text-mauve11 leading-[1.4]")}>{children}</p>
                </a>
            </NavigationMenu.Link>
        </li>
    ),
);
ListItem.displayName = "ListItem";

export default NavigationMenuComponent;
